module.exports = __webpack_public_path__ + "5642ea1e8973f3d64326e62781855fa1.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_analytics/icons/notification.png
// module id = 1267
// module chunks = 69